import { Injectable, Inject } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { API_URL } from '../models/api-url.token';
import { IExamQuestionVm } from '../exam-question-vm.model';
import { IExamQuestionIm } from '../exam-question-im.model';
import { IGovAdminQuestionUm } from '../gov-admin-question-um.model';
import { IGovAdminQuestionDm } from '../gov-admin-question-dm.model';
@Injectable({ providedIn: 'root' })
export class QuestionBaseService {
  private readonly baseUrl: string;
  constructor(private http: HttpClient, @Inject(API_URL) private apiUrl: string) {
    this.baseUrl = `${this.apiUrl}/QuestionBase`;
  }
  get(guid: string): Observable<IExamQuestionVm> {
    const headers = this.createHeaders();
    let params = new HttpParams();
    if (guid !== undefined && guid !== null) {
      params = params.set('guid', guid.toString());
    }
    return this.http.get<IExamQuestionVm>(this.baseUrl, { headers, params });
  }
  post(x: IExamQuestionIm): Observable<IExamQuestionVm> {
    const headers = this.createHeaders();
    return this.http.post<IExamQuestionVm>(this.baseUrl, x, { headers });
  }
  put(x: IGovAdminQuestionUm): Observable<IExamQuestionVm> {
    const headers = this.createHeaders();
    return this.http.put<IExamQuestionVm>(this.baseUrl, x, { headers });
  }
  delete(questionDm: IGovAdminQuestionDm): Observable<any> {
    const headers = this.createHeaders();
    let params = new HttpParams();
    return this.http.delete<any>(this.baseUrl, { headers, params, body: questionDm });
  }
  private createHeaders(): HttpHeaders {
    let headers = new HttpHeaders();
    const token = localStorage.getItem('authToken');
    if (token) headers = headers.set('Authorization', `Bearer ${token}`);
    return headers;
  }
}
